import React from 'react';
import { useSpring, animated } from 'react-spring';

const StartScreenParallaxPic = () => {
  const trans1 = (x, y) => `translate3d(${x / 10}px,${y / 10}px,0)`;
  const trans2 = (x, y) => `translate3d(${-x / 10}px,${-y / 10}px,0)`;
  const calc = (x, y) => [x - window.innerWidth / 2, y - window.innerHeight / 2];
  const [springProps, setSpringProps] = useSpring(() => ({
    xy: [0, 0],
    config: { mass: 10, tension: 550, friction: 140 },
  }));

  return (
    <div className="start-screen-img" onMouseMove={({ clientX: x, clientY: y }) => setSpringProps({ xy: calc(x, y) })}>
      <animated.div
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: '83.333%',
          height: '85.145%',
          background: 'rgba(255, 255, 255, 0.22)',
          opacity: 0.5,
          zIndex: 0,
          transform: springProps.xy.interpolate(trans1),
        }}
      />
      <animated.div
        style={{
          position: 'absolute',
          left: 0,
          bottom: 0,
          width: '71%',
          height: '71%',
          background: 'rgba(255, 255, 255, 0.23)',
          zIndex: 0,
          transform: springProps.xy.interpolate(trans2),
        }}
      />
      <div
        style={{
          position: 'absolute',
          paddingLeft: '8%',
          paddingTop: '8%',
          paddingRight: '9%',
          paddingBottom: '9%',
          zIndex: 1,
        }}
      >
        <img src="img/start-screen-title.jpg" className="is-block" />
      </div>
    </div>
  );
};

export default StartScreenParallaxPic;
